module.exports = __webpack_public_path__ + "static/media/BlackMagical.63eec83d.jpg";